<template>
  <div class="skeleton-card" part="skeleton-card">
    <div class="skeleton-image shimmer"></div>
    <div class="skeleton-title shimmer"></div>
    <div class="skeleton-title skeleton-title-short shimmer"></div>
    <div class="skeleton-button shimmer"></div>
  </div>
</template>

<style scoped>
.skeleton-card {
  border-radius: var(--vwc-border-radius-md);
  padding: var(--vwc-card-padding);
}

.skeleton-image {
  width: 100%;
  height: 180px;
  border-radius: var(--vwc-card-image-border-radius);
  background-color: var(--vwc-color-secondary, #e0d6c8);
}

@media screen and (max-width: 640px) {
  .skeleton-image {
    height: 35vw;
  }
}

.skeleton-title {
  height: 1em;
  width: 80%;
  margin-top: var(--vwc-spacing-sm);
  border-radius: 4px;
  background-color: var(--vwc-color-secondary, #e0d6c8);
}

.skeleton-title-short {
  width: 55%;
  margin-top: 0.5em;
}

.skeleton-button {
  height: 2em;
  width: 50%;
  margin-top: var(--vwc-spacing-sm);
  border-radius: var(--vwc-border-radius-full, 9999px);
  background-color: var(--vwc-color-secondary, #e0d6c8);
}

.shimmer {
  background: linear-gradient(
    90deg,
    var(--vwc-color-secondary, #e0d6c8) 25%,
    color-mix(in srgb, var(--vwc-color-secondary, #e0d6c8), white 40%) 50%,
    var(--vwc-color-secondary, #e0d6c8) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite ease-in-out;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
